// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import moment from 'moment';

import { useLocation } from 'react-router-dom';

const DiscountBandsTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const { pathname } = useLocation();
  
  const isPromotionsRoute = pathname.includes('/fare-products/promotions');
  const productType = isPromotionsRoute ? 'Promotions' : 'FareProducts';
  const productTerm = isPromotionsRoute ? 'Promotion' : 'Fare Product';
  const messageTransformer = (msg: string) => {
    if (!msg) return msg;
    return msg.replace(/discount bands/gi, `${productTerm}s`).replace(/discount band/gi, productTerm);
  };
  
  const pageTitle = isPromotionsRoute ? 'Promotions' : 'FareProducts';
  const addButtonLabel = isPromotionsRoute ? 'AddNewPromotion' : 'AddNewFareProduct';
  const baseUrl = isPromotionsRoute ? '/fare-products/promotions' : '/fare-products/fare-products';
  const deleteConfirmationMessage = isPromotionsRoute ? 'AreYouSureDeletePromotion' : 'AreYouSureDeleteFareProduct';


  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle={pageTitle}
      pageIcon={LocalOfferIcon}
      addButtonLabel={addButtonLabel}
      
      // ============ NAVIGATION URLs ============
      addPageUrl={`${baseUrl}/new`}
      viewPageUrl={`${baseUrl}/:id`}
      editPageUrl={`${baseUrl}/:id/edit?came_from=all`}
      
      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band?product_type=${productType}`}
      getApiMethod="GET"
      
      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band/:id`}
      deleteApiMethod="PATCH" // Backend update method handles deletion via is_active
      deleteBody={{ is_active: false }}
      
      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.discountBands"
      responsePaginationPath="data.data.pagination"
      
      // ============ TABLE CONFIGURATION ============
      idField="discount_bands_id"
      columns={[
        {
          field: 'code',
          headerKey: 'Code',
          align: 'center',
          sortable: true,
          sortField: 'db.code',
        },
        {
          field: 'name',
          headerKey: 'Name',
          align: 'center',
          sortable: true,
          sortField: currentLanguageCode === 'en-us' ? 'db.en_name' : 'db.name',
          render: (value, row) => currentLanguageCode === 'en-us' ? row.en_name : row.name,
        },
        {
          field: 'discount_pct',
          headerKey: 'DiscountPct',
          align: 'center',
          render: (value) => value ? `${value}%` : '-',
          sortable: true,
          sortField: 'db.discount_pct',
        },
        {
          field: 'discount_amount',
          headerKey: 'DiscountAmount',
          align: 'center',
          render: (value) => value ? `${value}` : '-',
          sortable: true,
          sortField: 'db.discount_amount',
        },
        {
          field: 'organisation_name',
          headerKey: 'Organisation',
          align: 'center',
          render: (value, row) => currentLanguageCode === 'en-us' ? row.org_en_name : row.org_ar_name,
        },
        {
          field: 'valid_date_from',
          headerKey: 'ValidFrom',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY') : '-',
          sortable: true,
          sortField: 'db.valid_date_from',
        },
        {
          field: 'valid_date_to',
          headerKey: 'ValidTo',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY') : '-',
          sortable: true,
          sortField: 'db.valid_date_to',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
          sortable: true,
          sortField: 'db.created_at',
        },
      ]}
      
      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchDiscountBandPlaceholder"
      searchInputWidth="270px"
      
      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'organisations_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
      ]}
      
      // ============ PERMISSIONS ============
      subsystemName={productType}
      permissionSystem="fares"
      
      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage={deleteConfirmationMessage}
      messageTransformer={messageTransformer}
    />
  );
};

export default DiscountBandsTable;
